 <template>
  <div>
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">Your coupons</h1>
          <h2 class="subtitle">Here are the coupons you already sent</h2>
          <b-message>
            <h2>You can also find the status of the coupon, based on what our staff has decided about</h2>
            <b-table :data="Object.values(statuses)" style="width: 500px; margin-top: 30px;">
              <template slot-scope="props">
                <b-table-column field="status" label="Status">
                  <span :class="`tag ${props.row.color}`">
                    <b>{{props.row.status.toUpperCase()}}</b>
                  </span>
                </b-table-column>
                <b-table-column field="description" label="Description">{{ props.row.desc }}</b-table-column>
              </template>
            </b-table>
          </b-message>
        </div>
      </div>
    </section>

    <div class="container" style="margin-top: 30px">
      <div class="columns">
        <div class="column">
          <b-table :data="rows" :paginated="true" :per-page="20">
            <template slot-scope="props">
              <b-table-column field="coupon" label="Coupon code" sortable>{{ props.row.coupon }}</b-table-column>

              <b-table-column field="link" label="Product link" sortable>
                <a :href="props.row.link">{{ truncate(props.row.link, 36) }}</a>
              </b-table-column>
              <b-table-column
                field="originalPrice"
                label="Original price"
                sortable
              >{{ props.row.originalPrice }}</b-table-column>
              <b-table-column
                field="newPrice"
                label="Discounted price"
                sortable
              >{{ props.row.newPrice }}</b-table-column>
              <b-table-column
                field="date"
                label="Sent by you on"
                sortable
              >{{ new Date(props.row.sent.seconds*1000).toLocaleDateString() }}</b-table-column>
              <b-table-column field="status" label="Status" sortable centered>
                <span
                  :class="`tag ${statuses[props.row.status] && statuses[props.row.status].color}`"
                >
                  <b>{{props.row.status.toUpperCase()}}</b>
                </span>
              </b-table-column>
              <b-table-column field="notes" label="Notes" sortable centered>{{props.row.notes}}</b-table-column>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "firebase";

const statuses = {
  rejected: {
    status: "rejected",
    color: "is-danger",
    desc: "Your coupon has been rejected"
  },
  published: {
    status: "published",
    color: "is-success",
    desc: "Your coupon has been published on our channels"
  },
  pending: {
    status: "pending",
    color: "is-warning",
    desc: "Your coupon is pending review from our staff"
  }
};

export default {
  name: "YourCoupons",
  data() {
    return {
      rows: [],
      statuses
    };
  },
  created() {
    const db = firebase.firestore();
    db.collection("deals")
      .where("uid", "==", this.user.data.uid)
      .get()
      .then(querySnapshot => {
        const rows = [];
        querySnapshot.forEach(doc => {
          const data = doc.data();
          if (!data.status) data.status = 'N/A'
          rows.push(data);
        });
        this.rows = rows;
      })
      .catch(function(error) {
        console.log("Error getting documents: ", error);
      });
  },
  computed: {
    ...mapGetters({
      // map `this.user` to `this.$store.getters.user`
      user: "user"
    })
  },
  methods: {
    truncate: (string, n) => {
      return string.length > n ? string.substr(0, n - 1) + "..." : string;
    }
  }
};
</script>
